<div
    class="box-old-version"
    *ngIf="showOldVersion"
>
    <div class="old-version-box-notification">
        کاربر گرامی، به دلیل قدیمی بودن نسخه اندروید دستگاه شما، لطفا جهت نمایش و
    خرید محصولات، از وبسایت نوار استفاده نمایید.
    </div>
    <div
        class="old-version-button"
        (click)="goToWeb()"
    >
        <navaar-button
            [type-button]="'button'"
            [color-name]="'yellow-icon'"
        >
            <span class="text-more">ورود به وبسایت نوار</span>
            <navaar-chevron-icon class="list-more"></navaar-chevron-icon>
        </navaar-button>
    </div>
</div>
<div
    class="shop-category"
    *ngIf="!showOldVersion"
>
    <navaar-header
        [title]="title"
        [color]="'#000000'"
    >
    </navaar-header>
    <section class="main-content" style="margin-top: 35px">
        <ng-template
            ngFor
            [ngForOf]="items"
            let-item
            let-i="index"
        >
            <navaar-banner
                *ngIf="item.sliderInfo"
                [items]="item.sliderInfo.slides"
                [type-banner]="'banner-slider'"
                [type-slider]="item.sliderInfo?.sliderType"
                [event-tracker-name]="'x_plp_banner'"
                [index-banner]="i"
            >
            </navaar-banner>
            <navaar-banner
                *ngIf="item.bannerInfo"
                [items]="item.bannerInfo"
                [type-banner]="'banner'"
                [event-tracker-name]="'x_plp_banner'"
                [index-banner]="i"
            ></navaar-banner>
            <ng-container *ngTemplateOutlet="TagList; context: { $implicit: i }"></ng-container>
            <navaar-carousel
                *ngIf="item.listInfo"
                [title]="item.listInfo.title"
                [typeOfCarousel]="item.listInfo.listMode"
                [items]="item.listInfo"
                [style-show-all]="'yellow'"
                [show-rate]="true"
                [identifier]="identifier"
                [type-url]="item.listInfo.apiUrl"
                [badge-type]="item.listInfo.badgeId"
                [rate-style]="{background: 'rgb(255, 181, 0)'}"
                [index-carousel]="i"
                [name-tracker-event]="'x_plp_list_item'"
            ></navaar-carousel>
        </ng-template>
        <div class="box-more-plp">
            <div class="more-button-plp">
                <div
                    class="container-btn"
                    (click)="goToPlpList(identifier, title)"
                    *ngIf="showMore"
                >
                    <navaar-button
                        [type-button]="'button'"
                        [color-name]="'yellow-icon'"
                    >
                        <span class="text-more">مشاهده همه</span>
                        <navaar-chevron-icon class="list-more"></navaar-chevron-icon>
                    </navaar-button>
                </div>
            </div>
        </div>
    </section>
</div>
<ng-template
    #TagList
    let-i
>
    <ng-container *ngIf="subgenres.length > 0">
        <div
            class="container-slider tagList"
            *ngIf="i === 0"
        >
            <div class="track-tag-list">
                <div
                    class="tag-item"
                    *ngFor="let item of subgenres"
                    (click)="onSubgenres(item.identifier, item.name)"
                >
                    <div
                        class="tag-item-title"
                        [textContent]="item.name"
                    ></div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>
